import { toast } from "vue3-toastify";
export function getError(error) {
  if (!error.errors) {
    toast.error(error);
  } else {
    for (const er of error.errors) {
      toast.error(er.message);
    }
  }
}
